export default {
  name: "FooterSection",
  data(){
    return({
      rights:{
        company_name: "Infinity",
        year: new Date().getFullYear()
      }
    })
  }
};
